export default function Divider() {
  return (
    <div className="md:mb-[10px]">
      <svg
        width="30"
        height="5"
        viewBox="0 0 30 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="0.5" width="30" height="4" rx="2" fill="#946FFF" />
      </svg>
    </div>
  );
}
